import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstDetalleMinuta = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_detalle_minuta', 
        name: 'Listado Detalle De Minutas', 
        component: ViewLstDetalleMinuta,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
